var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_733_1994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.325 10.8738L24.3233 10.8721L14.1253 0.674438C13.6906 0.239563 13.1126 0 12.4979 0C11.8832 0 11.3052 0.239372 10.8704 0.674248L0.677684 10.8667C0.67425 10.8702 0.670817 10.8738 0.667384 10.8772C-0.225255 11.775 -0.223729 13.2317 0.671771 14.1272C1.0809 14.5365 1.62125 14.7736 2.19898 14.7984C2.22245 14.8006 2.2461 14.8018 2.26994 14.8018H2.67639V22.3066C2.67639 23.7917 3.8847 25 5.37014 25H9.35993C9.76429 25 10.0924 24.6721 10.0924 24.2676V18.3838C10.0924 17.7061 10.6436 17.1549 11.3213 17.1549H13.6745C14.3522 17.1549 14.9035 17.7061 14.9035 18.3838V24.2676C14.9035 24.6721 15.2313 25 15.6359 25H19.6257C21.1111 25 22.3194 23.7917 22.3194 22.3066V14.8018H22.6963C23.3109 14.8018 23.8888 14.5624 24.3238 14.1275C25.2203 13.2305 25.2207 11.7714 24.325 10.8738Z",
    fill: "#F26C38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_733_1994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcn);
export default __webpack_public_path__ + "static/media/dashboard_icn.ea6bc1c18065ee32b747ec1f43d89542.svg";
export { ForwardRef as ReactComponent };